import { mapActions } from 'vuex';
import ApplicationsGrid from './components/ApplicationsGrid/ApplicationsGrid.vue';

export default {
	components: { ApplicationsGrid },
	data() {
		return {
			search: '',
		}
	},
	methods: {
		...mapActions(['getAllApplications']),
		hendleSearchClick() {
			this.getAllApplications({
				eisCode: this.search
			})
		},
	},
}